import { FC } from 'react';
import Button from '../../../../../components/Button/Button';
import Card from '../../../../../components/Card/Card';
import Modal from '../../../../../components/Modal/Modal';
import Table from '../../../../../components/Tables/Table/Table';
import styles from './PartialSuccessModal.module.css';
import { PartialSuccessModalProps } from './PartialSuccessModal.types';
import { useTranslation } from 'react-i18next';

const PartialSuccessModal: FC<PartialSuccessModalProps> = ({
  isOpen,
  onClose,
  storesWithErrors,
  storesSubmittedCount,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerContent={t('partialSuccessModal.headerText')}
      bodyContent={
        <div className={styles.body}>
          <p className={styles.description}>
            {t('partialSuccessModal.requestHasBeenSent', {
              success: storesSubmittedCount - storesWithErrors.length,
              total: storesSubmittedCount,
            })}
          </p>
          <p className={styles.description}>{t('partialSuccessModal.storesWereNotProcessed')}</p>
          <Card>
            <Table
              data={storesWithErrors}
              columns={[{ accessorKey: 'storeNo', header: t('partialSuccessModal.table.storeId') }]}
              includeMinWidth={false}
            />
          </Card>
        </div>
      }
      footerContent={
        <div className={styles.footer}>
          <Button onClick={onClose}>{t('partialSuccessModal.returnButton')}</Button>
        </div>
      }
    />
  );
};

export default PartialSuccessModal;
